import { lazy } from "react";

const Login = lazy(() => import("./pages/login/Login"));
const DashboardLayout = lazy(() => import("./pages/dashboard/DashboardLayout"));
const Ngo = lazy(() => import("./pages/dashboard/ngo/Ngo.jsx"));
const RegisterNgo = lazy(() =>
  import("./pages/dashboard/ngo/register-ngo/RegisterNgo.jsx")
);
const Events = lazy(() => import("./pages/dashboard/events/Events.jsx"));
const Event = lazy(() => import("./pages/dashboard/events/event/Event.jsx"));
const EventReview = lazy(() =>
  import("./pages/dashboard/events/review/EventReview.jsx")
);
const RegisteEvent = lazy(() =>
  import("./pages/dashboard/events/register-event/RegisterEvent.jsx")
);

const LeagueLeaderboard = lazy(() =>
  import("./pages/leaderboard/LeagueLeaderboard.jsx")
);
const TotalLeaderboard = lazy(() =>
  import("./pages/leaderboard/TotalLeaderboard.jsx")
);

let routes = [
  { path: `/`, element: <Login /> },
  // { path: `/dashboard`, element: <DashboardLayout /> },
  //   TODO: Make the Routes dynamic
  {
    path: `/dashboard`,
    element: <DashboardLayout />,
    children: [
      // { path: "ngo", element: <Ngo /> },
      // { path: "ngo/register-ngo", element: <RegisterNgo /> },
      // { path: "ngo/review/:ngoId", element: <NgoReview /> },
      { path: "events", element: <Events /> },
      { path: "events/register-event", element: <RegisteEvent /> },
      { path: "events/:eventId", element: <Event /> },
      { path: "events/review/:eventId", element: <EventReview /> },
      { path: "leaderboard/league", element: <LeagueLeaderboard /> },
      { path: "leaderboard/total", element: <TotalLeaderboard /> },
      // { path: "discounts", element: <Discounts /> },
    ],
  },
];

export default routes;
